

export default theme => ({
  root: {
    position: 'relative',
    background: theme.palette.common.white,
    display: 'flex',
    justifyContent: 'center',
  },
   root2:{
    position: 'relative',
    background: theme.palette.common.white,
    display: 'flex',
    justifyContent: 'center',
    marginTop: "-100px",
    backgroundColor: "transparent",
  },
  altura:{
    height:"830px",
    [theme.breakpoints.only("md")]: {
      height:"760px"
    },
    [theme.breakpoints.only("sm")]: {
      height:"760px"
    },
  },
  alturaOriginal:{
    height: "auto"
  }
});